import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { cloneDeep } from 'lodash';

import { AuthService } from '../auth.service';
import { ADFSSettings } from '../auth';
import { Enums } from '../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-interceptor-login',
  templateUrl: './interceptor-login.component.html',
  standalone: false,
})
export class InterceptorLoginComponent {
  public Enums = Enums;
  public authError: string | null;
  public authLoading: boolean;
  public authForm: UntypedFormGroup = new UntypedFormGroup({
    login: new UntypedFormControl('', Validators.required),
    password: new UntypedFormControl('', Validators.required),
  });
  public ADFSLoading: boolean;
  public ADFSSettings: ADFSSettings;
  public isUseADFS: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService
  ) {
    this.checkUseADFS();
  }

  private checkUseADFS() {
    this.ADFSLoading = true;
    this.authService.checkUseADFS().subscribe(
      (response) => {
        this.ADFSSettings = response.data;
        this.isUseADFS = this.ADFSSettings.adfs_auth_enable;

        if (this.isUseADFS) {
          this.authForm.controls['login'].setValue(this.authService.getADFSData().login || '');
        }

        this.ADFSLoading = false;
      },
      (error) => {
        this.isUseADFS = false;
        this.ADFSLoading = false;
      }
    );
  }

  public onSubmitAuthForm(): void {
    const authLoginFormObj = cloneDeep(this.authForm.value);

    if (this.isUseADFS) {
      authLoginFormObj.login = this.ADFSSettings.adfs_domain + '\\' + authLoginFormObj.login;
    }

    this.authLoading = true;
    this.authError = null;

    this.authService.login(authLoginFormObj).subscribe(
      (response) => {
        this.authLoading = false;

        if (this.isUseADFS) {
          this.authService.setADFSData({
            login: this.authForm.value.login,
          });
        }

        this.activeModal.close(response);
      },
      (error) => {
        this.authLoading = false;
        this.authError = Enums.errorCodes[100001];
      }
    );
  }
}
